// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeFanFollowRemoveFollowerBody = {
  accountId: string;
};

export type typeFanFollowRemoveFollowerOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { didRemove: boolean };
};

export type typeFanFollowRemoveFollowerOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeFanFollowRemoveFollowerOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeFanFollowRemoveFollowerOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaFanFollowRemoveFollowerBody = {
  type: "object",
  properties: { accountId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["accountId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createFanFollowRemoveFollower(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaFanFollowRemoveFollowerBody);
  }

  return async function postFanFollowRemoveFollower(
    payload: typeFanFollowRemoveFollowerBody,
  ): Promise<
    typeFanFollowRemoveFollowerOutput200 | typeFanFollowRemoveFollowerOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postFanFollowRemoveFollower" failed before calling the network. #e04d4479a7ac`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#e04d4479a7ac" },
        },
        data: null,
      } as typeFanFollowRemoveFollowerOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/fan-follow/remove-follower`,
      httpMethod: "POST",
      options,
    })) as
      | typeFanFollowRemoveFollowerOutput200
      | typeFanFollowRemoveFollowerOutput400;
  };
}
